<h1>{{ 'content.not-authorized' | translate }}</h1>

<p>{{ 'content.not-authorized-to-view-page' | translate }}</p>
